// import CustomResize from "./plugins/CustomResize.js";
// import UppyImageCompressor from "./plugins/UppyImageCompressor.js";
// 5MB
import FirebasePluginUppy from "./FirebasePluginUppy";
function UppyUpload(cropperOptions, actions, onSuccess, onClose) {
  // 500MB
  const MAXFILESIZE = 524288000;
  var uppy = window.Uppy.Core({
    restrictions: {
      maxNumberOfFiles: 5,
      maxFileSize: MAXFILESIZE,
      // allowedFileTypes: ['image/*']
    },
    browserBackButtonClose: true,
    onBeforeFileAdded: (currentFile, files) => {
      console.log(files);
      const modifiedFile = {
        ...currentFile,
        name: currentFile.name.replace(/ +/g, "-").trim(),
      };
      return modifiedFile;
    }
  })
    .use(window.Uppy.Dashboard, {
      target: "#drag-drop-area---airbook",
      autoOpenFileEditor: true,
      proudlyDisplayPoweredByUppy: false,
    })
    .use(FirebasePluginUppy);
  uppy.on("complete", (result) => {
    if (result) {
      uppy.close();
      console.log(
        "Upload complete! We’ve uploaded these files:",
        result.successful
      );
      onSuccess(result);
      if (onClose instanceof Function) {
        onClose();
      }
    }

  });
  uppy.on("dashboard:modal-closed", () => {
    if (onClose instanceof Function) {
      onClose();
    }
  })
  uppy.getPlugin("Dashboard").openModal();
}

export default UppyUpload;